import React from 'react';
import PropTypes from 'prop-types';

import {green500, greyishBlue400, red500} from "assets/jss/main";

VariationPercentage.propTypes = {
    value: PropTypes.number
};

function VariationPercentage({value}) {
    return (
        <div style={{
            fontWeight: 600,
            color: value === 0 ? greyishBlue400 : value < 0 ? red500 : green500
        }}>
            {value > 0 ? '+' : ''}{value}%
        </div>
    );
}

export default VariationPercentage;
